export default "__VITE_ASSET__DDbJY4z$__"